import { Pipe, PipeTransform } from '@angular/core';
import { FacetConfigResponse as FacetGroup } from '@models/api-search.models';

/**
 * Get only groups that contains values
 */
@Pipe({
    name: 'facetGroupsWithValues',
    standalone: true
})
export class FacetGroupsWithValuesPipe implements PipeTransform {
    transform(facetGroups?: FacetGroup[]): FacetGroup[] {
        if (!facetGroups) {
            return [];
        }
        return facetGroups.filter(group => group.values?.length);
    }
}
